import { getItem } from '@/utils/localstorage';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

// Todo: Place in types folder as it will be used elsewhere as well
interface PhoneForm {
  phone: string;
  photo: string[] | string;
  rememberMe: boolean;
}

interface OptForm {
  attemptId: string;
  code: string;
}

interface AuthState {
  phoneForm: PhoneForm;
  setPhoneForm: (arg0: PhoneForm) => void;

  otpForm: OptForm;
  setOtpForm: (arg0: OptForm) => void;

  loginEmail: string;
  setLoginEmail: (arg0: string) => void;
  resetLoginEmail: () => void;

  reset: () => void;
}

const initialState = {
  phoneForm: { phone: '', photo: '', rememberMe: false },
  otpForm: { attemptId: '', code: '' },
  loginEmail: ''
};

const useAuthStore = create(
  devtools<AuthState>((set) => ({
    ...initialState,

    setPhoneForm: (value: PhoneForm) =>
      set(() => ({
        phoneForm: {
          phone: value.phone,
          photo: value.photo,
          rememberMe: value.rememberMe
        }
      })),
    setOtpForm: (value: OptForm) =>
      set((val) => ({
        phoneForm: val.phoneForm,
        otpForm: {
          attemptId: value.attemptId,
          code: value.code
        }
      })),

    setLoginEmail: (val: string) => set(() => ({ loginEmail: val })),

    resetLoginEmail: () => set(() => ({ loginEmail: initialState.loginEmail })),

    reset: () => {
      set(initialState);
    }
  }))
);

export { useAuthStore };

export type { PhoneForm, OptForm };
